import { ImageProps } from './base';

export default function Visa({ width = '64px' }: ImageProps) {
  return (
    <svg
      fill='none'
      height='21'
      style={{ height: 'initial', width }}
      viewBox='0 0 32 21'
      width='32'
      xmlns='http://www.w3.org/2000/svg'
    >
      <title>Visa</title>
      <rect fill='#00579F' height='21' rx='4' width='32' />
      <path d='M13.6906 14.0724H11.8813L13.013 7.37555H14.8222L13.6906 14.0724Z' fill='white' />
      <path
        d='M20.249 7.53933C19.8921 7.40382 19.3261 7.25421 18.6261 7.25421C16.8394 7.25421 15.5811 8.16608 15.5734 9.46978C15.5585 10.4317 16.4743 10.9659 17.1591 11.2866C17.8591 11.6143 18.0971 11.8282 18.0971 12.1204C18.09 12.569 17.5314 12.7758 17.0105 12.7758C16.2881 12.7758 15.9011 12.6692 15.3129 12.4196L15.0746 12.3126L14.8214 13.8159C15.2458 14.0009 16.0276 14.1651 16.8393 14.1723C18.7379 14.1723 19.9738 13.2745 19.9885 11.8852C19.9957 11.1229 19.5122 10.5387 18.4697 10.0614C17.8369 9.75499 17.4493 9.54838 17.4493 9.23486C17.4567 8.94984 17.7771 8.65791 18.4915 8.65791C19.0797 8.64361 19.5119 8.77892 19.8393 8.91433L20.0029 8.98544L20.249 7.53933Z'
        fill='white'
      />
      <path
        d='M22.6547 11.7C22.8037 11.3152 23.3771 9.82624 23.3771 9.82624C23.3696 9.84054 23.5258 9.43441 23.6152 9.18509L23.7416 9.76213C23.7416 9.76213 24.0842 11.3651 24.1586 11.7C23.8759 11.7 23.0121 11.7 22.6547 11.7ZM24.8881 7.37555H23.4886C23.057 7.37555 22.7291 7.49656 22.5429 7.93119L19.8554 14.0724H21.7539C21.7539 14.0724 22.0664 13.2458 22.1336 13.0678C22.3419 13.0678 24.1887 13.0678 24.4567 13.0678C24.5086 13.3029 24.6725 14.0724 24.6725 14.0724H26.3478L24.8881 7.37555Z'
        fill='white'
      />
      <path
        d='M10.3698 7.37555L8.59786 11.9422L8.40423 11.016C8.07663 9.94735 7.04922 8.78625 5.90268 8.20892L7.52572 14.0653H9.43907L12.2831 7.37555H10.3698Z'
        fill='white'
      />
      <path
        d='M6.95247 7.37555H4.04139L4.01161 7.51086C6.28243 8.0666 7.78635 9.40619 8.40424 11.0163L7.77141 7.93849C7.66722 7.51077 7.34705 7.38966 6.95247 7.37555Z'
        fill='#FAA61A'
      />
    </svg>
  );
}
